(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1892],{

/***/ 54465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "loadStripe": function() { return /* binding */ loadStripe; }
/* harmony export */ });
var V3_URL = 'https://js.stripe.com/v3';
var V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var findScript = function findScript() {
  var scripts = document.querySelectorAll("script[src^=\"".concat(V3_URL, "\"]"));

  for (var i = 0; i < scripts.length; i++) {
    var script = scripts[i];

    if (!V3_URL_REGEX.test(script.src)) {
      continue;
    }

    return script;
  }

  return null;
};

var injectScript = function injectScript(params) {
  var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
  var script = document.createElement('script');
  script.src = "".concat(V3_URL).concat(queryString);
  var headOrBody = document.head || document.body;

  if (!headOrBody) {
    throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
  }

  headOrBody.appendChild(script);
  return script;
};

var registerWrapper = function registerWrapper(stripe, startTime) {
  if (!stripe || !stripe._registerWrapper) {
    return;
  }

  stripe._registerWrapper({
    name: 'stripe-js',
    version: "1.32.0",
    startTime: startTime
  });
};

var stripePromise = null;
var loadScript = function loadScript(params) {
  // Ensure that we only attempt to load Stripe.js at most once
  if (stripePromise !== null) {
    return stripePromise;
  }

  stripePromise = new Promise(function (resolve, reject) {
    if (typeof window === 'undefined') {
      // Resolve to null when imported server side. This makes the module
      // safe to import in an isomorphic code base.
      resolve(null);
      return;
    }

    if (window.Stripe && params) {
      console.warn(EXISTING_SCRIPT_MESSAGE);
    }

    if (window.Stripe) {
      resolve(window.Stripe);
      return;
    }

    try {
      var script = findScript();

      if (script && params) {
        console.warn(EXISTING_SCRIPT_MESSAGE);
      } else if (!script) {
        script = injectScript(params);
      }

      script.addEventListener('load', function () {
        if (window.Stripe) {
          resolve(window.Stripe);
        } else {
          reject(new Error('Stripe.js not available'));
        }
      });
      script.addEventListener('error', function () {
        reject(new Error('Failed to load Stripe.js'));
      });
    } catch (error) {
      reject(error);
      return;
    }
  });
  return stripePromise;
};
var initStripe = function initStripe(maybeStripe, args, startTime) {
  if (maybeStripe === null) {
    return null;
  }

  var stripe = maybeStripe.apply(undefined, args);
  registerWrapper(stripe, startTime);
  return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

// own script injection.

var stripePromise$1 = Promise.resolve().then(function () {
  return loadScript(null);
});
var loadCalled = false;
stripePromise$1["catch"](function (err) {
  if (!loadCalled) {
    console.warn(err);
  }
});
var loadStripe = function loadStripe() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  loadCalled = true;
  var startTime = Date.now();
  return stripePromise$1.then(function (maybeStripe) {
    return initStripe(maybeStripe, args, startTime);
  });
};




/***/ }),

/***/ 12797:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plans",
      function () {
        return __webpack_require__(17371);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 81222:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
function mapError(result, f) {
    if (result.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: result._0
        };
    } else {
        return {
            TAG: /* Error */ 1,
            _0: Curry._1(f, result._0)
        };
    }
}
function mapError2(result, f) {
    if (result.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: result._0
        };
    } else {
        return {
            TAG: /* Error */ 1,
            _0: Curry._1(f, result._0)
        };
    }
}
exports.mapError = mapError;
exports.mapError2 = mapError2; /* No side effect */ 


/***/ }),

/***/ 17371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _src_common_PagePlans_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40532);
/* harmony import */ var _utils_withApollo_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37947);


var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,_utils_withApollo_js__WEBPACK_IMPORTED_MODULE_1__/* .withApollo */ .C)(_src_common_PagePlans_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .make */ .Sy));


/***/ }),

/***/ 62718:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Generated by ReScript, PLEASE EDIT WITH CARE

var Caml_exceptions = __webpack_require__(96181);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Unknown_response = /* @__PURE__ */ Caml_exceptions.create("Next-SmartcutsMacros.GetStaticProps.Response.Unknown_response");
var Unknown_revalidate_value = /* @__PURE__ */ Caml_exceptions.create("Next-SmartcutsMacros.GetStaticProps.Response.Revalidate.Unknown_revalidate_value");
function seconds(s) {
    return s;
}
function $$boolean(b) {
    return b;
}
function classify(v) {
    if (typeof v === "number") {
        return {
            TAG: /* Seconds */ 0,
            _0: v
        };
    }
    if (typeof v === "boolean") {
        return {
            TAG: /* Boolean */ 1,
            _0: v
        };
    }
    throw {
        RE_EXN_ID: Unknown_revalidate_value,
        Error: new Error()
    };
}
var Revalidate = {
    Unknown_revalidate_value: Unknown_revalidate_value,
    seconds: seconds,
    $$boolean: $$boolean,
    classify: classify
};
var PropsWithRevalidate = {};
var RedirectWithRevalidate = {};
function makePropsWithRevalidate(v) {
    return v;
}
function makeRedirectWithRevalidate(v) {
    return v;
}
function makeNotFound(param) {
    return {
        notFound: true
    };
}
function classify$1(v) {
    if (Util$SmartcutsMacros.hasSingleKey(v, "props") || Util$SmartcutsMacros.hasKeys(v, [
        "props",
        "revalidate"
    ])) {
        return {
            TAG: /* PropsWithRevalidate */ 0,
            _0: v
        };
    }
    if (Util$SmartcutsMacros.hasSingleKey(v, "redirect") || Util$SmartcutsMacros.hasKeys(v, [
        "redirect",
        "revalidate"
    ])) {
        return {
            TAG: /* RedirectWithRevalidate */ 1,
            _0: v
        };
    }
    if (Util$SmartcutsMacros.hasSingleKey(v, "notFound")) {
        return /* NotFound */ 0;
    }
    throw {
        RE_EXN_ID: Unknown_response,
        Error: new Error()
    };
}
var $$Response = {
    Unknown_response: Unknown_response,
    Revalidate: Revalidate,
    PropsWithRevalidate: PropsWithRevalidate,
    RedirectWithRevalidate: RedirectWithRevalidate,
    makePropsWithRevalidate: makePropsWithRevalidate,
    makeRedirectWithRevalidate: makeRedirectWithRevalidate,
    makeNotFound: makeNotFound,
    classify: classify$1
};
var GetStaticProps = {
    $$Response: $$Response
};
var GetStaticPaths = {};
var Link = {};
var Events = {};
var Router = {
    Events: Events
};
var Head = {};
var WithInnerHtml = {};
var Script = {
    WithInnerHtml: WithInnerHtml
};
var $$Error = {};
var $$Request = {};
var $$Response$1 = {};
function MakeContext(Context) {
    return {};
}
var ExtraContextProperties = {};
function AppContext_pathname(prim) {
    return prim.pathname;
}
function AppContext_query(prim) {
    return prim.query;
}
function AppContext_asPath(prim) {
    return prim.asPath;
}
function AppContext_req(prim) {
    return prim.req;
}
function AppContext_res(prim) {
    return prim.res;
}
function AppContext_err(prim) {
    return prim.err;
}
var AppContext = {
    pathname: AppContext_pathname,
    query: AppContext_query,
    asPath: AppContext_asPath,
    req: AppContext_req,
    res: AppContext_res,
    err: AppContext_err
};
function MakePageContext(Context, AppContext) {
    return {
        pathname: function(prim) {
            return prim.pathname;
        },
        query: function(prim) {
            return prim.query;
        },
        asPath: function(prim) {
            return prim.asPath;
        },
        req: function(prim) {
            return prim.req;
        },
        res: function(prim) {
            return prim.res;
        },
        err: function(prim) {
            return prim.err;
        },
        appContext: function(prim) {
            return prim.ctx;
        },
        appTree: function(prim) {
            return prim.AppTree;
        }
    };
}
function PageContext_pathname(prim) {
    return prim.pathname;
}
function PageContext_query(prim) {
    return prim.query;
}
function PageContext_asPath(prim) {
    return prim.asPath;
}
function PageContext_req(prim) {
    return prim.req;
}
function PageContext_res(prim) {
    return prim.res;
}
function PageContext_err(prim) {
    return prim.err;
}
function PageContext_appContext(prim) {
    return prim.ctx;
}
function PageContext_appTree(prim) {
    return prim.AppTree;
}
var PageContext = {
    pathname: PageContext_pathname,
    query: PageContext_query,
    asPath: PageContext_asPath,
    req: PageContext_req,
    res: PageContext_res,
    err: PageContext_err,
    appContext: PageContext_appContext,
    appTree: PageContext_appTree
};
var $$Response$2 = {};
var GetServerSideProps = {
    $$Response: $$Response$2
};
function inject(_cls, _fn) {
    return _cls.getInitialProps = _fn;
}
function overrideToJSONAsNull(_apolloClient) {
    return _apolloClient.toJSON = function() {
        return null;
    };
}
exports.GetStaticProps = GetStaticProps;
exports.GetStaticPaths = GetStaticPaths;
exports.Link = Link;
exports.Router = Router;
exports.Head = Head;
exports.Script = Script;
exports.$$Error = $$Error;
exports.$$Request = $$Request;
exports.$$Response = $$Response$1;
exports.MakeContext = MakeContext;
exports.ExtraContextProperties = ExtraContextProperties;
exports.AppContext = AppContext;
exports.MakePageContext = MakePageContext;
exports.PageContext = PageContext;
exports.GetServerSideProps = GetServerSideProps;
exports.inject = inject;
exports.overrideToJSONAsNull = overrideToJSONAsNull; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 769:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Generated by ReScript, PLEASE EDIT WITH CARE

var Antd = __webpack_require__(17072);
var CssJs = __webpack_require__(62380);
var React = __webpack_require__(67294);
var ReactUtils$SmartcutsMacros = __webpack_require__(80310);
var errorAlert = CssJs.style([
    CssJs.maxWidth(CssJs.px(700)),
    CssJs.margin("auto")
]);
var Styles = {
    errorAlert: errorAlert
};
function ErrorMessage(Props) {
    var error = Props.error;
    return React.createElement(Antd.Alert, {
        description: React.createElement(React.Fragment, undefined, ReactUtils$SmartcutsMacros.s("Something went wrong. Please contact "), React.createElement("a", {
            href: "mailto:support@trysmartcuts.com"
        }, ReactUtils$SmartcutsMacros.s("support@trysmartcuts.com"))),
        message: React.createElement("strong", undefined, ReactUtils$SmartcutsMacros.s("Error. "), ReactUtils$SmartcutsMacros.s(error)),
        showIcon: true,
        type: "error",
        className: errorAlert
    });
}
var make = ErrorMessage;
exports.Styles = Styles;
exports.make = make; /* errorAlert Not a pure module */ 


/***/ }),

/***/ 40532:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
// Generated by ReScript, PLEASE EDIT WITH CARE

var Css = __webpack_require__(62418);
var Antd = __webpack_require__(17072);
var Curry = __webpack_require__(41386);
var React = __webpack_require__(67294);
var Head = (__webpack_require__(9008)["default"]);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Router = __webpack_require__(11163);
var Script = (__webpack_require__(4298)["default"]);
var Intl$SmartcutsMacros = __webpack_require__(93437);
var Next$SmartcutsMacros = __webpack_require__(62718);
var Apollo$SmartcutsMacros = __webpack_require__(16571);
var AppConfig$SmartcutsMacros = __webpack_require__(59730);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var ReactUtils$SmartcutsMacros = __webpack_require__(80310);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var ErrorMessage$SmartcutsMacros = __webpack_require__(769);
var LayoutPublic$SmartcutsMacros = __webpack_require__(64056);
var WithIdentity$SmartcutsMacros = __webpack_require__(45287);
var LoadingSpinner$SmartcutsMacros = __webpack_require__(93355);
var DataStore__User$SmartcutsMacros = __webpack_require__(25555);
var StripeUX__CheckoutButton$SmartcutsMacros = __webpack_require__(92894);
var StripeUX__ManageSubscriptionButton$SmartcutsMacros = __webpack_require__(24482);
var page = Curry._1(Css.style, {
    hd: Css.minHeight({
        NAME: "vh",
        VAL: 100.0
    }),
    tl: {
        hd: Css.minWidth({
            NAME: "vw",
            VAL: 100.0
        }),
        tl: {
            hd: Css.background({
                NAME: "hex",
                VAL: "f2f2f2"
            }),
            tl: {
                hd: Css.selector(".pageContent", {
                    hd: Css.minHeight({
                        NAME: "vh",
                        VAL: 100.0
                    }),
                    tl: {
                        hd: Css.width({
                            NAME: "percent",
                            VAL: 100.0
                        }),
                        tl: {
                            hd: Css.maxWidth({
                                NAME: "px",
                                VAL: 1000
                            }),
                            tl: {
                                hd: Css.margin("auto"),
                                tl: {
                                    hd: Css.boxSizing("borderBox"),
                                    tl: {
                                        hd: Css.padding({
                                            NAME: "px",
                                            VAL: 20
                                        }),
                                        tl: {
                                            hd: Css.background({
                                                NAME: "hex",
                                                VAL: "fff"
                                            }),
                                            tl: {
                                                hd: Css.selector(".headline", {
                                                    hd: Css.textAlign("center"),
                                                    tl: {
                                                        hd: Css.margin2({
                                                            NAME: "px",
                                                            VAL: 20
                                                        }, "zero"),
                                                        tl: {
                                                            hd: Css.selector("h1", {
                                                                hd: Css.fontSize({
                                                                    NAME: "px",
                                                                    VAL: 30
                                                                }),
                                                                tl: {
                                                                    hd: Css.marginBottom({
                                                                        NAME: "px",
                                                                        VAL: 10
                                                                    }),
                                                                    tl: /* [] */ 0
                                                                }
                                                            }),
                                                            tl: /* [] */ 0
                                                        }
                                                    }
                                                }),
                                                tl: {
                                                    hd: Css.selector(".allPlans", {
                                                        hd: Css.display("flex"),
                                                        tl: {
                                                            hd: Css.flexDirection("row"),
                                                            tl: {
                                                                hd: Css.justifyContent("center"),
                                                                tl: {
                                                                    hd: Css.flexWrap("wrap"),
                                                                    tl: {
                                                                        hd: Css.selector(".servicePlan", {
                                                                            hd: Css.width({
                                                                                NAME: "px",
                                                                                VAL: 300
                                                                            }),
                                                                            tl: {
                                                                                hd: Css.margin({
                                                                                    NAME: "px",
                                                                                    VAL: 5
                                                                                }),
                                                                                tl: {
                                                                                    hd: Css.selector(".ant-card-body", {
                                                                                        hd: Css.height({
                                                                                            NAME: "percent",
                                                                                            VAL: 100.0
                                                                                        }),
                                                                                        tl: {
                                                                                            hd: Css.display("flex"),
                                                                                            tl: {
                                                                                                hd: Css.flexDirection("column"),
                                                                                                tl: /* [] */ 0
                                                                                            }
                                                                                        }
                                                                                    }),
                                                                                    tl: {
                                                                                        hd: Css.selector("h2", {
                                                                                            hd: Css.fontWeight("semiBold"),
                                                                                            tl: {
                                                                                                hd: Css.textTransform("uppercase"),
                                                                                                tl: /* [] */ 0
                                                                                            }
                                                                                        }),
                                                                                        tl: {
                                                                                            hd: Css.selector(".manageSubscription", {
                                                                                                hd: Css.color({
                                                                                                    NAME: "hex",
                                                                                                    VAL: "1890ff"
                                                                                                }),
                                                                                                tl: {
                                                                                                    hd: Css.position("absolute"),
                                                                                                    tl: {
                                                                                                        hd: Css.right({
                                                                                                            NAME: "px",
                                                                                                            VAL: 24
                                                                                                        }),
                                                                                                        tl: {
                                                                                                            hd: Css.top({
                                                                                                                NAME: "px",
                                                                                                                VAL: 24
                                                                                                            }),
                                                                                                            tl: {
                                                                                                                hd: Css.padding("zero"),
                                                                                                                tl: /* [] */ 0
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }),
                                                                                            tl: {
                                                                                                hd: Css.selector(".servicePlanDetails, .servicePlanDetails > *", {
                                                                                                    hd: Css.margin2({
                                                                                                        NAME: "px",
                                                                                                        VAL: 10
                                                                                                    }, "zero"),
                                                                                                    tl: {
                                                                                                        hd: Css.color({
                                                                                                            NAME: "hex",
                                                                                                            VAL: "333"
                                                                                                        }),
                                                                                                        tl: /* [] */ 0
                                                                                                    }
                                                                                                }),
                                                                                                tl: {
                                                                                                    hd: Css.selector("ul.features", {
                                                                                                        hd: Css.paddingLeft({
                                                                                                            NAME: "px",
                                                                                                            VAL: 15
                                                                                                        }),
                                                                                                        tl: /* [] */ 0
                                                                                                    }),
                                                                                                    tl: {
                                                                                                        hd: Css.selector(".billed", {
                                                                                                            hd: Css.color({
                                                                                                                NAME: "hex",
                                                                                                                VAL: "27ae60"
                                                                                                            }),
                                                                                                            tl: /* [] */ 0
                                                                                                        }),
                                                                                                        tl: {
                                                                                                            hd: Css.selector(".subscriptionPrice", {
                                                                                                                hd: Css.fontSize({
                                                                                                                    NAME: "px",
                                                                                                                    VAL: 24
                                                                                                                }),
                                                                                                                tl: {
                                                                                                                    hd: Css.fontWeight("semiBold"),
                                                                                                                    tl: /* [] */ 0
                                                                                                                }
                                                                                                            }),
                                                                                                            tl: {
                                                                                                                hd: Css.selector(".billed, .subscriptionPrice", {
                                                                                                                    hd: Css.display("block"),
                                                                                                                    tl: {
                                                                                                                        hd: Css.textAlign("right"),
                                                                                                                        tl: /* [] */ 0
                                                                                                                    }
                                                                                                                }),
                                                                                                                tl: {
                                                                                                                    hd: Css.selector(".actions", {
                                                                                                                        hd: Css.justifySelf("flexEnd"),
                                                                                                                        tl: {
                                                                                                                            hd: Css.marginTop("auto"),
                                                                                                                            tl: {
                                                                                                                                hd: Css.selector("& button, & a", {
                                                                                                                                    hd: Css.width({
                                                                                                                                        NAME: "percent",
                                                                                                                                        VAL: 100.0
                                                                                                                                    }),
                                                                                                                                    tl: {
                                                                                                                                        hd: Css.marginTop({
                                                                                                                                            NAME: "px",
                                                                                                                                            VAL: 10
                                                                                                                                        }),
                                                                                                                                        tl: {
                                                                                                                                            hd: Css.selector("&.currentPlan[disabled]", {
                                                                                                                                                hd: Css.background({
                                                                                                                                                    NAME: "hex",
                                                                                                                                                    VAL: "27ae60"
                                                                                                                                                }),
                                                                                                                                                tl: {
                                                                                                                                                    hd: Css.color({
                                                                                                                                                        NAME: "hex",
                                                                                                                                                        VAL: "fff"
                                                                                                                                                    }),
                                                                                                                                                    tl: {
                                                                                                                                                        hd: Css.borderColor({
                                                                                                                                                            NAME: "hex",
                                                                                                                                                            VAL: "219653"
                                                                                                                                                        }),
                                                                                                                                                        tl: /* [] */ 0
                                                                                                                                                    }
                                                                                                                                                }
                                                                                                                                            }),
                                                                                                                                            tl: /* [] */ 0
                                                                                                                                        }
                                                                                                                                    }
                                                                                                                                }),
                                                                                                                                tl: /* [] */ 0
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }),
                                                                                                                    tl: /* [] */ 0
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }),
                                                                        tl: /* [] */ 0
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }),
                                                    tl: /* [] */ 0
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var pageLoader = Curry._1(Css.style, {
    hd: Css.display("flex"),
    tl: {
        hd: Css.flexDirection("row"),
        tl: {
            hd: Css.selector(".loader", {
                hd: Css.padding({
                    NAME: "px",
                    VAL: 30
                }),
                tl: {
                    hd: Css.margin("auto"),
                    tl: {
                        hd: Css.justifySelf("center"),
                        tl: {
                            hd: Css.textAlign("center"),
                            tl: {
                                hd: Css.color({
                                    NAME: "hex",
                                    VAL: "828282"
                                }),
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            }),
            tl: /* [] */ 0
        }
    }
});
var Style = {
    page: page,
    pageLoader: pageLoader
};
function PagePlans$PageLoader(Props) {
    return React.createElement("section", {
        className: pageLoader
    }, React.createElement("div", {
        className: "loader"
    }, React.createElement(LoadingSpinner$SmartcutsMacros.make, {}), React.createElement("div", undefined, ReactUtils$SmartcutsMacros.s("Loading"))));
}
var PageLoader = {
    make: PagePlans$PageLoader
};
function PagePlans$PriceInfoOrBilledStatus(Props) {
    var price = Props.price;
    return React.createElement(React.Fragment, undefined, price > 0 ? React.createElement("label", {
        className: "billed"
    }, ReactUtils$SmartcutsMacros.s("Billed monthly")) : null, React.createElement("label", {
        className: "subscriptionPrice"
    }, ReactUtils$SmartcutsMacros.s(price === -1 ? "" : StringUtils$SmartcutsMacros.currencyFormat.format(price / 100.0))));
}
var PriceInfoOrBilledStatus = {
    make: PagePlans$PriceInfoOrBilledStatus
};
function PagePlans$PlanCard(Props) {
    var plan = Props.plan;
    var user = Props.user;
    var currentSubscription = Props.currentSubscription;
    var router = Router.useRouter();
    var servicePlanId = plan._id;
    var title = plan.name;
    var description = plan.description;
    var price = plan.subscriptionPrice;
    var executionSteps;
    if (plan.executionSteps === -1) {
        executionSteps = "Unlimited";
    } else {
        var arg = {};
        executionSteps = (function(param) {
            return new Intl.NumberFormat(param, arg);
        })(Intl$SmartcutsMacros.Locale.enUS).format(plan.executionSteps);
    }
    var tmp;
    if (currentSubscription !== undefined && !(price === -1 || price === 0 || currentSubscription.servicePlan.subscriptionPrice === 0)) {
        var arg$1 = currentSubscription.stripeCustomerId;
        var tmp$1;
        if (currentSubscription.servicePlan._id === servicePlanId) {
            tmp$1 = "Manage";
        } else {
            var arg$2 = currentSubscription.subtotal;
            tmp$1 = price < function(param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
            }("Expected subscription subtotal") ? "Downgrade" : "Upgrade";
        }
        tmp = React.createElement(StripeUX__ManageSubscriptionButton$SmartcutsMacros.make, {
            stripeCustomerId: function(param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
            }("Expect subscription.stripeCustomerId if subscription.price > 0"),
            router: router,
            children: ReactUtils$SmartcutsMacros.s(tmp$1)
        });
    } else {
        tmp = null;
    }
    return React.createElement(Antd.Card, {
        className: "servicePlan",
        children: null
    }, tmp, React.createElement("h2", undefined, ReactUtils$SmartcutsMacros.s(title)), React.createElement("div", {
        className: "servicePlanDetails"
    }, React.createElement("p", undefined, ReactUtils$SmartcutsMacros.s(description)), React.createElement("ul", {
        className: "features"
    }, React.createElement("li", undefined, ReactUtils$SmartcutsMacros.s("" + executionSteps + " smartcut steps per month")))), React.createElement("section", {
        className: "actions"
    }, React.createElement(PagePlans$PriceInfoOrBilledStatus, {
        price: price
    }), React.createElement(StripeUX__CheckoutButton$SmartcutsMacros.make, {
        servicePlanId: servicePlanId,
        price: price,
        user: user,
        currentSubscription: currentSubscription
    })));
}
var PlanCard = {
    make: PagePlans$PlanCard
};
function PagePlans$AllPlans(Props) {
    var allPlans = Props.allPlans;
    var user = Props.user;
    var currentSubscription = Props.currentSubscription;
    React.useEffect(function() {
        if (user !== undefined) {
            var email = user.email;
            var userId = user.userId;
            if (currentSubscription !== undefined) {
                var plan = currentSubscription.servicePlan.name;
                var isPaying = Belt_Option.map(currentSubscription.subtotal, function(subtotal) {
                    return subtotal > 0;
                });
                var tmp = {
                    email: email,
                    plan: plan
                };
                if (isPaying !== undefined) {
                    tmp.paying = Caml_option.valFromOption(isPaying);
                }
                window.analytics.identify(userId, tmp);
                var tmp$1 = {
                    email: email,
                    plan: plan
                };
                if (isPaying !== undefined) {
                    tmp$1.isPaying = Caml_option.valFromOption(isPaying);
                }
                window.freshpaint.identify(userId, tmp$1);
            } else {
                window.analytics.identify(userId, {
                    email: email
                });
                window.freshpaint.identify(userId, {
                    email: email
                });
            }
        }
    }, []);
    return React.createElement("section", {
        className: "allPlans"
    }, Belt_Array.map(ArrayUtils$SmartcutsMacros.sort2(allPlans, function(planA, planB) {
        if (planA.executionSteps === -1) {
            return 1;
        } else if (planB.executionSteps === -1 || planA.executionSteps < planB.executionSteps) {
            return -1;
        } else if (planA.executionSteps > planB.executionSteps) {
            return 1;
        } else {
            return 0;
        }
    }), function(plan) {
        return React.createElement(PagePlans$PlanCard, {
            plan: plan,
            user: user,
            currentSubscription: currentSubscription,
            key: plan._id
        });
    }));
}
var AllPlans = {
    make: PagePlans$AllPlans
};
function PagePlans(Props) {
    return WithIdentity$SmartcutsMacros.make(function(userIdentity) {
        var router = Router.useRouter();
        var match = Curry.app(DataStore__User$SmartcutsMacros.AllServicePlans.use, [
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
        var match$1 = Curry.app(DataStore__User$SmartcutsMacros.MyActiveSubscriptions.use, [
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
        var response = match.data;
        var error = match.error;
        var tmp;
        if (match.loading) {
            tmp = React.createElement(PagePlans$PageLoader, {});
        } else if (error !== undefined) {
            tmp = React.createElement(ErrorMessage$SmartcutsMacros.make, {
                error: error.message
            });
        } else if (response !== undefined) {
            var allPlans = Belt_Array.keepMap(response.allServicePlans.data, function(x) {
                return x;
            });
            if (userIdentity !== undefined) {
                var match$2 = match$1.data;
                var error$1 = match$1.error;
                if (match$1.loading) {
                    tmp = React.createElement(PagePlans$PageLoader, {});
                } else if (error$1 !== undefined) {
                    tmp = React.createElement(React.Fragment, undefined, React.createElement(PagePlans$AllPlans, {
                        allPlans: allPlans
                    }), React.createElement(ErrorMessage$SmartcutsMacros.make, {
                        error: error$1.message
                    }));
                } else if (match$2 !== undefined) {
                    var subscriptionData = match$2.myActiveSubscriptions.data;
                    if (subscriptionData.length > 1) {
                        console.warn("Found > 1 active subscriptions; only expected 1", subscriptionData);
                    }
                    var currentSubscription = Belt_Option.flatMap(Belt_Array.get(subscriptionData, 0), function(x) {
                        return x;
                    });
                    var tmp$1 = {
                        allPlans: allPlans,
                        user: userIdentity
                    };
                    if (currentSubscription !== undefined) {
                        tmp$1.currentSubscription = Caml_option.valFromOption(currentSubscription);
                    }
                    tmp = React.createElement(PagePlans$AllPlans, tmp$1);
                } else {
                    tmp = React.createElement(PagePlans$AllPlans, {
                        allPlans: allPlans,
                        user: userIdentity
                    });
                }
            } else {
                tmp = React.createElement(PagePlans$AllPlans, {
                    allPlans: allPlans
                });
            }
        } else {
            tmp = React.createElement("div", undefined, ReactUtils$SmartcutsMacros.s("Nothing to see here."));
        }
        return React.createElement(LayoutPublic$SmartcutsMacros.make, {
            onClickCallToAction: function(param) {
                router.push("/", undefined, undefined);
            },
            children: null
        }, React.createElement(Script, {
            id: "stripe",
            src: "https://js.stripe.com/v3/",
            type_: "text/javascript"
        }), React.createElement(Head, {
            children: null
        }, React.createElement("title", undefined, ReactUtils$SmartcutsMacros.s("Plans | Smartcuts")),  false ? 0 : null, React.createElement("link", {
            href: "/favicon-16.png",
            rel: "icon",
            sizes: "16x16",
            type: "image/png"
        }), React.createElement("link", {
            href: "/favicon-32.png",
            rel: "icon",
            sizes: "32x32",
            type: "image/png"
        }), React.createElement("link", {
            href: "/favicon-96.png",
            rel: "icon",
            sizes: "96x96",
            type: "image/png"
        })), React.createElement(Antd.Layout, {
            className: page,
            children: React.createElement("section", {
                className: "pageContent"
            }, React.createElement("section", {
                className: "headline"
            }, React.createElement("h1", undefined, ReactUtils$SmartcutsMacros.s("Choose the plan that's right for you")), React.createElement("p", undefined, ReactUtils$SmartcutsMacros.s("And use Smartcuts to automate your work on web"))), tmp)
        }));
    });
}
function getStaticProps(param) {
    var client = Apollo$SmartcutsMacros.makeClient(undefined, AppConfig$SmartcutsMacros.publicUserToken, undefined);
    return Curry._6(client.rescript_query, {
        query: DataStore__User$SmartcutsMacros.AllServicePlans.query,
        Raw: DataStore__User$SmartcutsMacros.AllServicePlans.Raw,
        parse: DataStore__User$SmartcutsMacros.AllServicePlans.parse,
        serialize: DataStore__User$SmartcutsMacros.AllServicePlans.serialize,
        serializeVariables: DataStore__User$SmartcutsMacros.AllServicePlans.serializeVariables
    }, undefined, undefined, undefined, undefined, undefined).then(function(_response) {
        var apolloStaticCache = client.cache.extract();
        return Promise.resolve(Curry._1(Next$SmartcutsMacros.GetStaticProps.$$Response.makePropsWithRevalidate, {
            props: {
                apolloStaticCache: apolloStaticCache
            },
            revalidate: Caml_option.some(Curry._1(Next$SmartcutsMacros.GetStaticProps.$$Response.Revalidate.seconds, 60))
        }));
    });
}
var AllServicePlans;
var MyActiveSubscriptions;
var make = PagePlans;
__webpack_unused_export__ = AllServicePlans;
__webpack_unused_export__ = MyActiveSubscriptions;
__webpack_unused_export__ = Style;
__webpack_unused_export__ = PageLoader;
__webpack_unused_export__ = PriceInfoOrBilledStatus;
__webpack_unused_export__ = PlanCard;
__webpack_unused_export__ = AllPlans;
exports.Sy = make;
__webpack_unused_export__ = getStaticProps; /* page Not a pure module */ 


/***/ }),

/***/ 45287:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Fetch = __webpack_require__(84403);
var React = __webpack_require__(67294);
var Js_exn = __webpack_require__(82900);
var Client = __webpack_require__(15586);
var PageHelpers$SmartcutsMacros = __webpack_require__(12871);
function make(make$1) {
    var match1 = React.useState(function() {
        return {
            userIdentity: undefined
        };
    });
    var setState = match1[1];
    var userIdentity = match1[0].userIdentity;
    React.useEffect(function() {
        fetch("/api/identity", Fetch.RequestInit.make(/* Get */ 0, {
            Accept: "application/json"
        }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined)).then(function(res) {
            var match = res.status;
            if (match !== 200) {
                if (match !== 401) {
                    return res.text().then(Js_exn.raiseError);
                } else {
                    return Promise.resolve(undefined);
                }
            } else {
                return res.json().then(function(json) {
                    Curry._1(setState, function(_state) {
                        return {
                            userIdentity: json
                        };
                    });
                    return Promise.resolve(undefined);
                });
            }
        });
    }, []);
    if (userIdentity === undefined) {
        return Curry._1(make$1, userIdentity);
    }
    var client = PageHelpers$SmartcutsMacros.loadApolloClient(userIdentity.token);
    return React.createElement(Client.ApolloProvider, {
        client: client,
        children: Curry._1(make$1, userIdentity)
    });
}
exports.make = make; /* react Not a pure module */ 


/***/ }),

/***/ 2908:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Generated by ReScript, PLEASE EDIT WITH CARE

var Css = __webpack_require__(62418);
var Curry = __webpack_require__(41386);
var React = __webpack_require__(67294);
var Link = (__webpack_require__(41664)["default"]);
var ReactUtils$SmartcutsMacros = __webpack_require__(80310);
var styles = {
    marginRight: "10px"
};
function Header(Props) {
    var home = Props.home;
    var onClickCallToAction = Props.onClickCallToAction;
    return React.createElement("header", {
        className: Curry._1(Css.style, {
            hd: Css.width({
                NAME: "percent",
                VAL: 100
            }),
            tl: {
                hd: Css.display("flex"),
                tl: {
                    hd: Css.alignItems("center"),
                    tl: {
                        hd: Css.justifyContent("spaceBetween"),
                        tl: {
                            hd: Css.height(Css.px(100)),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        })
    }, React.createElement("div", {
        className: Curry._1(Css.style, {
            hd: Css.display("flex"),
            tl: {
                hd: Css.flexDirection("row"),
                tl: {
                    hd: Css.justifyContent("spaceBetween"),
                    tl: {
                        hd: Css.width({
                            NAME: "percent",
                            VAL: 100
                        }),
                        tl: {
                            hd: Css.maxWidth(Css.px(1140)),
                            tl: {
                                hd: Css.marginLeft("auto"),
                                tl: {
                                    hd: Css.marginRight("auto"),
                                    tl: {
                                        hd: Css.alignItems("center"),
                                        tl: /* [] */ 0
                                    }
                                }
                            }
                        }
                    }
                }
            }
        })
    }, React.createElement("h1", {
        className: Curry._1(Css.style, {
            hd: Css.fontFamily({
                NAME: "custom",
                VAL: '"Helvetica Neue", Helvetica, Arial, sans-serif'
            }),
            tl: {
                hd: Css.margin("zero"),
                tl: {
                    hd: Css.color({
                        NAME: "hex",
                        VAL: "1A8FE6"
                    }),
                    tl: /* [] */ 0
                }
            }
        })
    }, home ? React.createElement(React.Fragment, undefined, React.createElement("img", {
        className: Curry._1(Css.style, {
            hd: Css.width(Css.px(40)),
            tl: {
                hd: Css.verticalAlign("middle"),
                tl: {
                    hd: Css.marginRight({
                        NAME: "px",
                        VAL: 10
                    }),
                    tl: /* [] */ 0
                }
            }
        }),
        src: "/img/logo66.png"
    }), React.createElement("span", {
        className: Curry._1(Css.style, {
            hd: Css.fontSize(Css.px(30)),
            tl: {
                hd: Css.fontWeight({
                    NAME: "num",
                    VAL: 400
                }),
                tl: {
                    hd: Css.media("(max-width: 414px)", {
                        hd: Css.fontSize(Css.px(20)),
                        tl: /* [] */ 0
                    }),
                    tl: /* [] */ 0
                }
            }
        })
    }, ReactUtils$SmartcutsMacros.s("smartcuts"))) : React.createElement(Link, {
        href: "/",
        children: React.createElement("a", {
            className: Curry._1(Css.style, {
                hd: Css.textDecoration("none"),
                tl: {
                    hd: Css.color({
                        NAME: "hex",
                        VAL: "1A8FE6"
                    }),
                    tl: /* [] */ 0
                }
            })
        }, React.createElement("img", {
            className: Curry._1(Css.style, {
                hd: Css.verticalAlign("middle"),
                tl: {
                    hd: Css.marginRight({
                        NAME: "px",
                        VAL: 20
                    }),
                    tl: /* [] */ 0
                }
            }),
            src: "/img/logo66.png"
        }), React.createElement("span", undefined, ReactUtils$SmartcutsMacros.s("smartcuts")))
    })), React.createElement("nav", {
        className: Curry._1(Css.style, {
            hd: Css.display("flex"),
            tl: {
                hd: Css.flexDirection("row"),
                tl: {
                    hd: Css.alignItems("center"),
                    tl: {
                        hd: Css.justifyContent("flexEnd"),
                        tl: {
                            hd: Css.flexGrow(1),
                            tl: {
                                hd: Css.flexShrink(1),
                                tl: {
                                    hd: Css.flexBasis({
                                        NAME: "percent",
                                        VAL: 1
                                    }),
                                    tl: {
                                        hd: Css.media("(max-width: 414px)", {
                                            hd: Css.display("none"),
                                            tl: /* [] */ 0
                                        }),
                                        tl: /* [] */ 0
                                    }
                                }
                            }
                        }
                    }
                }
            }
        })
    }, React.createElement(Link, {
        href: "/login",
        children: React.createElement("a", {
            className: Curry._1(Css.style, {
                hd: Css.fontFamily({
                    NAME: "custom",
                    VAL: '"Helvetica Neue", Helvetica, Arial, sans-serif'
                }),
                tl: {
                    hd: Css.color({
                        NAME: "hex",
                        VAL: "1A8FE6"
                    }),
                    tl: {
                        hd: Css.textDecoration("none"),
                        tl: {
                            hd: Css.fontSize({
                                NAME: "px",
                                VAL: 20
                            }),
                            tl: {
                                hd: Css.marginRight(Css.px(24)),
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            })
        }, ReactUtils$SmartcutsMacros.s("Login"))
    })), React.createElement("button", {
        className: Curry._1(Css.style, {
            hd: Css.backgroundColor({
                NAME: "hex",
                VAL: "fd6f2f"
            }),
            tl: {
                hd: Css.color({
                    NAME: "hex",
                    VAL: "fff"
                }),
                tl: {
                    hd: Css.borderRadius(Css.px(3)),
                    tl: {
                        hd: Css.padding2(Css.px(8), Css.px(20)),
                        tl: {
                            hd: Css.fontWeight({
                                NAME: "num",
                                VAL: 600
                            }),
                            tl: {
                                hd: Css.textTransform("uppercase"),
                                tl: {
                                    hd: Css.cursor("pointer"),
                                    tl: {
                                        hd: Css.borderStyle("none"),
                                        tl: {
                                            hd: Css.height(Css.px(40)),
                                            tl: {
                                                hd: Css.media("(max-width: 414px)", {
                                                    hd: Css.fontSize(Css.px(12)),
                                                    tl: /* [] */ 0
                                                }),
                                                tl: /* [] */ 0
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }),
        onClick: function(_event) {
            return Curry._1(onClickCallToAction, undefined);
        }
    }, ReactUtils$SmartcutsMacros.s("Request "), React.createElement("span", {
        className: Curry._1(Css.style, {
            hd: Css.media("(max-width: 414px)", {
                hd: Css.display("none"),
                tl: /* [] */ 0
            }),
            tl: /* [] */ 0
        })
    }, ReactUtils$SmartcutsMacros.s("Early ")), ReactUtils$SmartcutsMacros.s("Access"))));
}
var make = Header;
exports.styles = styles;
exports.make = make; /* Css Not a pure module */ 


/***/ }),

/***/ 64056:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Generated by ReScript, PLEASE EDIT WITH CARE

var Css = __webpack_require__(62418);
var Curry = __webpack_require__(41386);
var React = __webpack_require__(67294);
var Head = (__webpack_require__(9008)["default"]);
var Header$SmartcutsMacros = __webpack_require__(2908);
var ReactUtils$SmartcutsMacros = __webpack_require__(80310);
function LayoutPublic(Props) {
    var homeOpt = Props.home;
    var onClickCallToAction = Props.onClickCallToAction;
    var children = Props.children;
    var home = homeOpt !== undefined ? homeOpt : false;
    return React.createElement(React.Fragment, undefined, React.createElement(Head, {
        children: null
    }, React.createElement("link", {
        href: "/favicon-16.png",
        rel: "icon",
        sizes: "16x16",
        type: "image/png"
    }), React.createElement("link", {
        href: "/favicon-32.png",
        rel: "icon",
        sizes: "32x32",
        type: "image/png"
    }), React.createElement("link", {
        href: "/favicon-96.png",
        rel: "icon",
        sizes: "96x96",
        type: "image/png"
    })), React.createElement(Header$SmartcutsMacros.make, {
        home: home,
        onClickCallToAction: onClickCallToAction
    }), React.createElement("div", {
        className: Curry._1(Css.style, {
            hd: Css.display("flex"),
            tl: {
                hd: Css.flexDirection("column"),
                tl: {
                    hd: Css.minHeight({
                        NAME: "vh",
                        VAL: 80.0
                    }),
                    tl: {
                        hd: Css.fontFamily({
                            NAME: "custom",
                            VAL: '"Helvetica Neue", Helvetica, Arial, sans-serif'
                        }),
                        tl: {
                            hd: Css.alignItems("center"),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        })
    }, children), React.createElement("footer", {
        className: Curry._1(Css.style, {
            hd: Css.display("flex"),
            tl: {
                hd: Css.alignItems("center"),
                tl: {
                    hd: Css.justifyContent("spaceAround"),
                    tl: {
                        hd: Css.flexWrap("wrap"),
                        tl: {
                            hd: Css.fontFamily({
                                NAME: "custom",
                                VAL: '"Helvetica Neue", Helvetica, Arial, sans-serif'
                            }),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        })
    }, React.createElement("div", {
        className: Curry._1(Css.style, {
            hd: Css.color(Css.hex("acacae")),
            tl: {
                hd: Css.fontSize({
                    NAME: "px",
                    VAL: 12
                }),
                tl: {
                    hd: Css.selector("& > a", {
                        hd: Css.color(Css.hex("acacae")),
                        tl: /* [] */ 0
                    }),
                    tl: /* [] */ 0
                }
            }
        })
    }, ReactUtils$SmartcutsMacros.s("2021 \xa9 Smartcuts"), ReactUtils$SmartcutsMacros.s(" | "), React.createElement("a", {
        href: "/privacy_policy.html",
        target: "_blank"
    }, ReactUtils$SmartcutsMacros.s("Privacy policy")), ReactUtils$SmartcutsMacros.s(" | "), React.createElement("a", {
        href: "/terms_of_service.html",
        target: "_blank"
    }, ReactUtils$SmartcutsMacros.s("Terms of service")), ReactUtils$SmartcutsMacros.s(" | "), React.createElement("a", {
        href: "/cookie_policy.html",
        target: "_blank"
    }, ReactUtils$SmartcutsMacros.s("Cookie policy")))));
}
var make = LayoutPublic;
exports.make = make; /* Css Not a pure module */ 


/***/ }),

/***/ 93355:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Generated by ReScript, PLEASE EDIT WITH CARE

var Css = __webpack_require__(62418);
var Antd = __webpack_require__(17072);
var Curry = __webpack_require__(41386);
var React = __webpack_require__(67294);
var Icons = __webpack_require__(90677);
function LoadingSpinner(Props) {
    var className = Props.className;
    var tmp = {
        indicator: React.createElement(Icons.LoadingOutlined, {
            className: Curry._1(Css.style, {
                hd: Css.fontSize(Css.px(24)),
                tl: /* [] */ 0
            }),
            spin: true
        })
    };
    if (className !== undefined) {
        tmp.className = className;
    }
    return React.createElement(Antd.Spin, tmp);
}
var make = LoadingSpinner;
exports.make = make; /* Css Not a pure module */ 


/***/ }),

/***/ 92894:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Generated by ReScript, PLEASE EDIT WITH CARE

var Antd = __webpack_require__(17072);
var Curry = __webpack_require__(41386);
var Fetch = __webpack_require__(84403);
var React = __webpack_require__(67294);
var Js_dict = __webpack_require__(97076);
var Caml_option = __webpack_require__(57175);
var Json_decode = __webpack_require__(50957);
var Json_encode = __webpack_require__(82065);
var Router = __webpack_require__(11163);
var Icons = __webpack_require__(90677);
var StripeJs = __webpack_require__(54465);
var Util$SmartcutsMacros = __webpack_require__(25092);
var ReactUtils$SmartcutsMacros = __webpack_require__(80310);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var PromiseUtils$SmartcutsMacros = __webpack_require__(57019);
var StripeUX__ManageSubscriptionButton$SmartcutsMacros = __webpack_require__(24482);
var stripePromise = StripeJs.loadStripe("pk_live_51I9eZHCQaNwGRfoIQutVABw2PuUDRT8ckJlQV9Ef7thhrRq5ORTBSuFj9Q5vrHLBLXLKOFvO8krSAbpYta5QtYNc00I40DRklP");
function checkout(servicePlanId, onError) {
    fetch("/api/stripe/checkout", Fetch.RequestInit.make(/* Post */ 2, Caml_option.some(Js_dict.fromArray([
        [
            "Content-type",
            "application/json"
        ]
    ])), Caml_option.some(JSON.stringify(Json_encode.object_({
        hd: [
            "servicePlanId",
            servicePlanId
        ],
        tl: /* [] */ 0
    }))), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined)).then(function(response) {
        var statusCode = response.status;
        if (statusCode >= 400) {
            if (statusCode >= 402) {
                return Util$SmartcutsMacros.logAndRaiseJsError("Unexpcted statusCode " + String(statusCode));
            } else {
                return PromiseUtils$SmartcutsMacros.resolveWith(function(message) {
                    console.error(message);
                }, response.text());
            }
        } else if (statusCode !== 200) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Unexpcted statusCode " + String(statusCode));
        } else {
            return Promise.all([
                stripePromise,
                response.json()
            ]).then(function(param) {
                var sessionId = Json_decode.field("id", Json_decode.string, param[1]);
                return param[0].redirectToCheckout({
                    sessionId: sessionId
                });
            });
        }
    }).catch(function(error) {
        Curry._1(onError, error);
        return Promise.resolve(undefined);
    });
}
function StripeUX__CheckoutButton(Props) {
    var servicePlanId = Props.servicePlanId;
    var price = Props.price;
    var user = Props.user;
    var currentSubscription = Props.currentSubscription;
    var router = Router.useRouter();
    var match = React.useState(function() {
        return {
            checkoutInProgress: undefined
        };
    });
    var setState = match[1];
    var checkoutInProgress = match[0].checkoutInProgress;
    var initCheckout = function initCheckout(param) {
        Curry._1(setState, function(param) {
            return {
                checkoutInProgress: servicePlanId
            };
        });
        return checkout(servicePlanId, function(error) {
            console.error(error);
            return Curry._1(setState, function(param) {
                return {
                    checkoutInProgress: undefined
                };
            });
        });
    };
    if (price === -1) {
        return React.createElement(Antd.Button, {
            href: "https://forms.gle/SnGTm1yH25baHM8z8",
            size: "large",
            target: "_blank",
            type: "primary",
            children: ReactUtils$SmartcutsMacros.s("Get in touch")
        });
    }
    if (user === undefined) {
        return React.createElement(Antd.Button, {
            href: "login?redirect=" + encodeURIComponent("/plans"),
            size: "large",
            type: "primary",
            children: ReactUtils$SmartcutsMacros.s("Log in and subscribe")
        });
    }
    if (currentSubscription !== undefined && currentSubscription.servicePlan._id === servicePlanId) {
        return React.createElement(Antd.Button, {
            disabled: true,
            icon: React.createElement(Icons.CheckCircleFilled, {}),
            size: "large",
            type: "primary",
            className: "currentPlan",
            children: ReactUtils$SmartcutsMacros.s("Current plan")
        });
    }
    if (checkoutInProgress !== undefined) {
        if (checkoutInProgress === servicePlanId) {
            return React.createElement(Antd.Button, {
                disabled: true,
                icon: React.createElement(Icons.LoadingOutlined, {}),
                size: "large",
                type: "primary",
                children: ReactUtils$SmartcutsMacros.s("Loading")
            });
        } else {
            return React.createElement(Antd.Button, {
                disabled: true,
                size: "large",
                type: "primary",
                children: ReactUtils$SmartcutsMacros.s("Switch to this plan")
            });
        }
    }
    if (currentSubscription === undefined) {
        return React.createElement(Antd.Button, {
            size: "large",
            type: "primary",
            onClick: function(_event) {
                return initCheckout(undefined);
            },
            children: ReactUtils$SmartcutsMacros.s("Start with this plan")
        });
    }
    if (currentSubscription.servicePlan.subscriptionPrice === 0) {
        return React.createElement(Antd.Button, {
            size: "large",
            type: "primary",
            onClick: function(_event) {
                return initCheckout(undefined);
            },
            children: ReactUtils$SmartcutsMacros.s("Start with this plan")
        });
    }
    if (currentSubscription.servicePlan.subscriptionPrice <= 0) {
        return React.createElement(Antd.Button, {
            disabled: price === 0,
            size: "large",
            type: "primary",
            onClick: function(_event) {
                return initCheckout(undefined);
            },
            children: ReactUtils$SmartcutsMacros.s("Switch to this plan")
        });
    }
    var arg = currentSubscription.stripeCustomerId;
    return React.createElement(StripeUX__ManageSubscriptionButton$SmartcutsMacros.make, {
        type_: "button",
        stripeCustomerId: function(param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg);
        }("Expect subscription.stripeCustomerId if subscription.price > 0"),
        router: router,
        children: ReactUtils$SmartcutsMacros.s("Switch to this plan")
    });
}
var make = StripeUX__CheckoutButton;
exports.stripePromise = stripePromise;
exports.checkout = checkout;
exports.make = make; /* stripePromise Not a pure module */ 


/***/ }),

/***/ 24482:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Generated by ReScript, PLEASE EDIT WITH CARE

var Antd = __webpack_require__(17072);
var CssJs = __webpack_require__(62380);
var React = __webpack_require__(67294);
var StripeUX__Shared$SmartcutsMacros = __webpack_require__(58832);
var button = CssJs.selector(".manageSubscription", [
    CssJs.color({
        NAME: "hex",
        VAL: "1890ff"
    }),
    CssJs.position("absolute"),
    CssJs.right({
        NAME: "px",
        VAL: 24
    }),
    CssJs.top({
        NAME: "px",
        VAL: 24
    }),
    CssJs.padding("zero")
]);
var Style = {
    button: button
};
function StripeUX__ManageSubscriptionButton(Props) {
    var type_ = Props.type_;
    var stripeCustomerId = Props.stripeCustomerId;
    var router = Props.router;
    var children = Props.children;
    if (type_ === "button") {
        return React.createElement(Antd.Button, {
            size: "large",
            type: "primary",
            onClick: function(_event) {
                return StripeUX__Shared$SmartcutsMacros.manageSubscription(stripeCustomerId, router);
            },
            children: children
        });
    }
    return React.createElement("a", {
        className: "manageSubscription",
        onClick: function(_event) {
            return StripeUX__Shared$SmartcutsMacros.manageSubscription(stripeCustomerId, router);
        }
    }, children);
}
var make = StripeUX__ManageSubscriptionButton;
exports.Style = Style;
exports.make = make; /* button Not a pure module */ 


/***/ }),

/***/ 58832:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Generated by ReScript, PLEASE EDIT WITH CARE

var Fetch = __webpack_require__(84403);
var Js_dict = __webpack_require__(97076);
var Caml_option = __webpack_require__(57175);
var Json_decode = __webpack_require__(50957);
var Json_encode = __webpack_require__(82065);
var Util$SmartcutsMacros = __webpack_require__(25092);
var PromiseUtils$SmartcutsMacros = __webpack_require__(57019);
function manageSubscription(stripeCustomerId, router) {
    fetch("/api/stripe/portal", Fetch.RequestInit.make(/* Post */ 2, Caml_option.some(Js_dict.fromArray([
        [
            "Content-type",
            "application/json"
        ]
    ])), Caml_option.some(JSON.stringify(Json_encode.object_({
        hd: [
            "customer",
            stripeCustomerId
        ],
        tl: /* [] */ 0
    }))), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined)).then(function(response) {
        var statusCode = response.status;
        if (statusCode === 200) {
            return PromiseUtils$SmartcutsMacros.resolveWith(function(json) {
                var redirectUrl = Json_decode.field("url", Json_decode.string, json);
                router.push(redirectUrl, undefined, undefined);
            }, response.json());
        } else if (statusCode >= 400 || statusCode < 200) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Unexpcted statusCode " + String(statusCode));
        } else {
            return Promise.resolve(undefined);
        }
    });
}
exports.manageSubscription = manageSubscription; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 37947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ withApollo; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53768);
/* harmony import */ var _packages_data_src_Apollo_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16571);
/* harmony import */ var _src_common_AppConfig_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59730);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


// Static Server Generation (SSG) with Apollo caching.
// Borrowed from https://github.com/vercel/next.js/discussions/11957



var globalApolloClient;
function initApolloClient(initialState) {
    if (!globalApolloClient) {
        globalApolloClient = (0,_packages_data_src_Apollo_bs_js__WEBPACK_IMPORTED_MODULE_2__.makeClient)(initialState, _src_common_AppConfig_bs_js__WEBPACK_IMPORTED_MODULE_3__.publicUserToken, null);
    } else if (initialState) {
        globalApolloClient.cache.restore(_objectSpread({}, globalApolloClient.cache.extract(), initialState));
    }
    return globalApolloClient;
}
function withApollo(PageComponent) {
    var WithApollo = function(_param) {
        var apolloStaticCache = _param.apolloStaticCache, pageProps = _objectWithoutProperties(_param, [
            "apolloStaticCache"
        ]);
        // HERE WE USE THE PASSED CACHE
        var client = initApolloClient(apolloStaticCache);
        // and here we have the initialized client 🙂
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .ApolloProvider */ .e, {
            client: client,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PageComponent, _objectSpread({}, pageProps))
        });
    };
    // if you also use it for SSR
    if (PageComponent.getInitialProps) {
        WithApollo.getInitialProps = function() {
            var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(ctx) {
                var pageProps;
                return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            pageProps = {};
                            if (!PageComponent.getInitialProps) {
                                _ctx.next = 5;
                                break;
                            }
                            _ctx.next = 4;
                            return PageComponent.getInitialProps(ctx);
                        case 4:
                            pageProps = _ctx.sent;
                        case 5:
                            return _ctx.abrupt("return", pageProps);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(ctx) {
                return _ref.apply(this, arguments);
            };
        }();
    }
    // Set the correct displayName in development
    if (false) { var displayName; }
    return WithApollo;
}


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(63573)


/***/ }),

/***/ 69852:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Webapi__Dom__Event = __webpack_require__(71451);

var include = Webapi__Dom__Event.Impl({});

var eventPhase = include.eventPhase;

exports.eventPhase = eventPhase;
/* include Not a pure module */


/***/ }),

/***/ 39575:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Webapi__Dom__Event = __webpack_require__(71451);
var Webapi__Dom__UiEvent = __webpack_require__(91208);
var Webapi__Dom__MouseEvent = __webpack_require__(49116);

var include = Webapi__Dom__Event.Impl({});

Webapi__Dom__UiEvent.Impl({});

var include$1 = Webapi__Dom__MouseEvent.Impl({});

var eventPhase = include.eventPhase;

var getModifierState = include$1.getModifierState;

exports.eventPhase = eventPhase;
exports.getModifierState = getModifierState;
/* include Not a pure module */


/***/ }),

/***/ 63056:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Webapi__Dom__Event = __webpack_require__(71451);
var Webapi__Dom__UiEvent = __webpack_require__(91208);

var include = Webapi__Dom__Event.Impl({});

Webapi__Dom__UiEvent.Impl({});

var eventPhase = include.eventPhase;

exports.eventPhase = eventPhase;
/* include Not a pure module */


/***/ }),

/***/ 82371:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Webapi__Dom__Event = __webpack_require__(71451);
var Webapi__Dom__UiEvent = __webpack_require__(91208);

var include = Webapi__Dom__Event.Impl({});

Webapi__Dom__UiEvent.Impl({});

var eventPhase = include.eventPhase;

exports.eventPhase = eventPhase;
/* include Not a pure module */


/***/ }),

/***/ 41702:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Webapi__Dom__Event = __webpack_require__(71451);
var Webapi__Dom__Types = __webpack_require__(97088);
var Webapi__Dom__UiEvent = __webpack_require__(91208);

var include = Webapi__Dom__Event.Impl({});

Webapi__Dom__UiEvent.Impl({});

function getModifierState(self, key) {
  return self.getModifierState(Webapi__Dom__Types.encodeModifierKey(key));
}

var eventPhase = include.eventPhase;

exports.eventPhase = eventPhase;
exports.getModifierState = getModifierState;
/* include Not a pure module */


/***/ }),

/***/ 49116:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Webapi__Dom__Event = __webpack_require__(71451);
var Webapi__Dom__Types = __webpack_require__(97088);
var Webapi__Dom__UiEvent = __webpack_require__(91208);

function Impl(T) {
  var getModifierState = function (self, key) {
    return self.getModifierState(Webapi__Dom__Types.encodeModifierKey(key));
  };
  return {
          getModifierState: getModifierState
        };
}

var include = Webapi__Dom__Event.Impl({});

Webapi__Dom__UiEvent.Impl({});

function getModifierState(self, key) {
  return self.getModifierState(Webapi__Dom__Types.encodeModifierKey(key));
}

var eventPhase = include.eventPhase;

exports.Impl = Impl;
exports.eventPhase = eventPhase;
exports.getModifierState = getModifierState;
/* include Not a pure module */


/***/ }),

/***/ 91208:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Webapi__Dom__Event = __webpack_require__(71451);

function Impl(T) {
  return {};
}

var include = Webapi__Dom__Event.Impl({});

var eventPhase = include.eventPhase;

exports.Impl = Impl;
exports.eventPhase = eventPhase;
/* include Not a pure module */


/***/ }),

/***/ 53329:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var Webapi__Dom__Event = __webpack_require__(71451);
var Webapi__Dom__Types = __webpack_require__(97088);
var Webapi__Dom__UiEvent = __webpack_require__(91208);
var Webapi__Dom__MouseEvent = __webpack_require__(49116);

var include = Webapi__Dom__Event.Impl({});

Webapi__Dom__UiEvent.Impl({});

var include$1 = Webapi__Dom__MouseEvent.Impl({});

function deltaMode(self) {
  return Webapi__Dom__Types.decodeDeltaMode(self.deltaMode);
}

var eventPhase = include.eventPhase;

var getModifierState = include$1.getModifierState;

exports.eventPhase = eventPhase;
exports.getModifierState = getModifierState;
exports.deltaMode = deltaMode;
/* include Not a pure module */


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,4885,4951,9525,7072,2380,4797,8245,7025,677,4397,6513,1664,9359,310,2567,2349,5418,5129,3661,9003,1166,545,9804,2888,179], function() { return __webpack_exec__(25436), __webpack_exec__(12797); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);